import { UserTypes } from "./../constants/ActionTypes"

const User = (user = {
  id: "",
  displayName: ""
}, action) =>
{
  switch (action.type)
  {
    case UserTypes.LOGIN:
      return ({ id: "0", displayName: action.payload });
    case UserTypes.LOGOUT:
      break;
    default:
      return user;
  }
}
export default User;